/*
 * @Author: ZhangWeilun
 * @Date: 2019-01-19 11:39:14
 * @Email: me@zhangweilun.com
 * @Description: 
 */

import axios from "@/util/axios";
import { api } from "@/routes/api";

const CHANGE_MENU_DATA = "CHANGE_MENU_DATA";
const CHANGELOADING = "change_loading";

const initState = {
  menuList: [],
  menuArrayList: [],
  loading: false
}

export function Base(state = initState, action) {
  switch (action.type) {
    case CHANGE_MENU_DATA:
      return { ...state, ...action.payload };
    case CHANGELOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}

function changeMenuData(menuList) {
  const menuArrayList = getMenuArrayList(JSON.parse(JSON.stringify(menuList)));
  return { type: CHANGE_MENU_DATA, payload: { menuList, menuArrayList } }
}

export function changeLoading(loading) {
  return { type: CHANGELOADING, payload: loading }
}

export function getMenuList() {
  return async (dispatch, getState) => {
    const res = await axios.post(api.getCatsList);
    if (res.code === 0) {
      dispatch(changeMenuData(res.data.treeData));
    }
  }
}

function getMenuArrayList(list) {
  const menuList = list;
  list.forEach(v => {
    menuList.push(...v.subcats);
  })
  return menuList;
}
